export default {
  title: 'Vos questions de sécurité ont été mises à jour.',
  information: 'Vous pouvez utiliser vos réponses dès maintenant.',
};
